{{#if showLink}}
    <li class="selectable"><a href="#" class="btn btn-tertiary grid-save-view-btn">{{locale "saveThisView"}}</a></li>
{{else}}
    <form class="grid-saved-views-form">
        <div class="col-12">
            <label for="grid-save-this-view-input-{{cid}}" class="sr-only">{{locale "saveThisView"}}</label>
            <input id="grid-save-this-view-input-{{cid}}" type="text" class="form-control js-grid-save-view-input" maxlength="50" name="name" data-bind="model">
            <span class="help-block" data-bind="model" data-validate="name"></span>
        </div>
        <div class="row">
            <div class="col-6">
                <button class="btn btn-primary">{{locale "save"}}</button>
            </div>
            <div class="col-6">
                <button class="btn btn-secondary js-grid-save-view-cancel-btn">{{locale "cancel"}}</button>
            </div>
        </div>
    </form>
{{/if}}
{{#unless isEmpty}}
    <li class="divider"></li>
{{/unless}}